import React, { useState, useEffect } from "react";
import { 
  IoFlag,
  IoCheckmarkCircleOutline 
} from "react-icons/io5";
import Toggle from "react-toggle";
import * as actionCreators from "../../modules/actions/index";
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
  Row,
} from "reactstrap";
import ReactTooltip from "react-tooltip";
import axios from "../../axios";
import * as url from "../../utils/url";
import { toastContainer } from "../../utils/toast";
import { connect } from "react-redux";

function ReportStoryModal({
  isTextOnly,
  isReportedItem,
  story,
  handleFlagSuccess,
  isComment,
  renderFlagged,
  handleUnflagSuccess,
  orgAdmin,
  orgChangeSuccess
}) {
  const [isComplete, setIsComplete] = useState(false);
  const [open, setOpen] = useState(false);
  const [anonymous, setAnonymous] = useState(false);
  const [isFlagged, setIsFlagged] = useState(
    story.isFlagged && story.isFlagged.status
  );
  const [unflagOpen, setUnflagOpen] = useState(false);

  const [flagResponse, setFlagResponse] = useState("");
  const [moderationNotes, setModerationNotes] = useState([{ text: "" }]);

  useEffect(() => {
    setIsFlagged(story.isFlagged && story.isFlagged.status);
  }, [story]);

  const reportPost = () => {
    let payload = {
      isAnonymous: anonymous,
      status: true,
      storyId: story._id,
      flagResponse,
    };

    axios
      .put(url.flagContent(story._id), payload)
      .then(({ data }) => {
        console.log("data ---- ", data.data);

        toastContainer(
          "This content has been flagged for review by your organizations EA. Thank you for making your workplace safer.",
          "success"
        );
        setOpen(false);
        isReportedItem("");
        handleFlagSuccess(data.data.story);
       orgChangeSuccess(data.data.orgUpdate)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCancel = () => {
    setIsComplete(false);
    setOpen(false);
    setAnonymous(false);
    isReportedItem("");
  };
  const handleCancelUnflag = () => {
    setIsComplete(false);
    setOpen(false);
    setAnonymous(false);
    setUnflagOpen(false);
    isReportedItem("");
  };

  const handleUnflagContent = () => {
    const notes = moderationNotes.filter((x) => x.text);
    let payload = {
      isAnonymous: anonymous,
      status: false,
      storyId: story._id,
      moderationNotes: notes,
    };
    axios
      .put(url.flagContent(story._id), payload)
      .then(({ data }) => {

        toastContainer(
          "This content has now been approved and will no longer be hidden from view.",
          "success"
        );

        if (isComment) {
          handleUnflagSuccess(story._id);
        } else {
          handleUnflagSuccess({
            ...story,
            unflagged: true,
            isFlagged: { ...data.data.story.isFlagged },
          });
        }
        orgChangeSuccess(data.data.orgUpdate)

        setUnflagOpen(false);
        isReportedItem("");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const addModerationNote=()=>{
  //   let notes = [...moderationNotes];
  //   notes.push({text:""})

  //   setModerationNotes(notes)
  // }

  // const removeModerationNote=(index)=>{
  //   let notes = [...moderationNotes];

  //   if(index==0){
  //     notes = []
  //   }else{
  //     notes = notes.splice(index,1);

  //   }

  //   setModerationNotes(notes)
  // }

  const handleModerationNoteChange = (e, index) => {
    const value = e.target.value;

    let notes = [...moderationNotes];

    notes[index].text = value;

    setModerationNotes(notes);
  };

  const setReportModal = (val) => {
    if (val == "flag") {
      setOpen(true);
      isReportedItem(story._id);
    } else {
      setUnflagOpen(true);
      isReportedItem(story._id);
    }
  };

  return (
    <span className="">
      <div
        className={
          isTextOnly
            ? ""
            : isComment
            ? "comment-flag-container"
            : "stories-flag-container"
        }
        onClick={() => {
          if (!isFlagged) {
            // setOpen(true);
            setReportModal("flag");
          } else {
            if (orgAdmin) {
              // setUnflagOpen(true);
              setReportModal("unflag");
            }
          }
        }}
        data-tip={isFlagged ? (orgAdmin ? "Approve" : "") : "Report"}
      >
        {isTextOnly ? (
          isFlagged ? (
            <span>
            <IoCheckmarkCircleOutline size={"18px"} color={"white"} />
            <span className="chart-list-dropdown-options-text">
              Approve?{window.location &&
                        window.location.pathname &&
                        window.location.pathname.includes("/reporting/story-comment") ? (
                          <span className="chart-list-dropdown-options-text">( {story.type === "story" ? "Story" : "Comment"} )</span>
                        ) : (
                          ""
                        )}
            </span>
            </span>
          ) : (
            <span>
            <IoFlag size={"18px"} color={"white"} />
            <span className="chart-list-dropdown-options-text">
              Report
              </span>
            </span>
          )
        ) : (
          <IoFlag size={"14px"} color={isFlagged ? "red" : "gray"} />
        )}
        <ReactTooltip />
        {/* {window.location &&
        window.location.pathname &&
        window.location.pathname.includes("/reporting/story-comment") ? (
          <span className="chart-list-dropdown-options-text">( {story.type === "story" ? "Story" : "Comment"} )</span>
        ) : (
          ""
        )} */}
      </div>
      <Modal
        isOpen={open}
        className="dashboardArchiveModalContainer createModalContainer story-report-modal"
      >
        <ModalHeader
          className="dashboardHeader story-report-modal-header"
          // charCode="X"
          //   toggle={()=>this.closeActionsModal()}
        >
          <div className="dashboardModalTitle">
            Do you want to report this content?
          </div>
        </ModalHeader>
        <ModalBody className="dashboardModalBody archiveDashboardModalContent">
          {isComplete ? (
            <span>
              The content has been{" "}
              <b> Reported {anonymous ? "Anonymously" : ""}</b>.
            </span>
          ) : (
            <span>
              <span>
                By flagging or reporting this content, it will be removed from
                view and sent to the EA in this account for review.
              </span>

              <div className="my-4">
                <span className="mr-3">Report</span>

                <Toggle
                  icons={false}
                  checked={anonymous}
                  onChange={(e) => setAnonymous(e.target.checked)}
                />

                <span className="ml-3">Report Anonymously</span>
              </div>

              <div className="my-3">
                <textarea
                  rows={3}
                  className={"grp_create_description_txt"}
                  value={flagResponse}
                  onChange={(e) => {
                    setFlagResponse(e.target.value);
                  }}
                  placeholder="Please add your comment about reporting this content"
                />
              </div>

              <div
                className="submitPrivacyContainer archiveBtnContainer"
                style={{ padding: "10px 0px 0px 0px" }}
              >
                <Button
                  className={`archiveDashboardModalBtn`}
                  onClick={reportPost}
                >
                  <span className="">
                    Report {anonymous ? "Anonymously" : ""}
                  </span>
                </Button>

                <Button
                  outline
                  color="secondary"
                  className="cancelDashboardModalBtn"
                  onClick={handleCancel}
                >
                  <span className="">Cancel</span>
                </Button>
              </div>
            </span>
          )}
        </ModalBody>
      </Modal>
      {console.log(unflagOpen)}
      <Modal
        isOpen={unflagOpen}
        className="dashboardModalContainer story-report-modal"
      >
        <ModalHeader
          className="dashboardHeader story-report-modal-header"
          // charCode="X"
          //   toggle={()=>this.closeActionsModal()}
        >
          <div className="dashboardModalTitle">
            Do you want to approve this content?
          </div>
        </ModalHeader>
        <ModalBody>
          <span>
            By Approving this content, it will be removed from Reporting and
            visible in culture app posts. Feel free to add a comment about why this item has been approved below. 
          </span>

          <div>
         

            <div className="my-3">
              {/* {
                 moderationNotes.map((item,index) => {
                   return <Row className="my-2">
                     <Col sm={11}>
                     <Input placeholder="Please enter a note ..." value={item.text} onChange={(e) => handleModerationNoteChange(e,index)} />
                     </Col>
                    <Button size="sm" className="float-right" color="danger" onClick={()=> removeModerationNote(index)} > X  </Button> 
                   </Row>
                 }  )
               } */}

              <textarea
                rows={3}
                className={"grp_create_description_txt"}
                value={moderationNotes[0] && moderationNotes[0].text}
                onChange={(e) => {
                  handleModerationNoteChange(e, 0);
                }}
                placeholder="Please add your comment about reporting this content"
              />
            </div>
          </div>

          <div
            className="archiveBtnContainer"
            style={{ padding: "10px 0px 0px 0px" }}
          >
            <Button
              className="unflag-success-btn"
              onClick={handleUnflagContent}
              color="success"
            >
              <span className="">Approve and unflag</span>
            </Button>

            <Button
              outline
              color="secondary"
              className="cancelDashboardModalBtn"
              onClick={handleCancelUnflag}
            >
              <span className="">Cancel</span>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </span>
  );
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data)=> dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportStoryModal);
